class PayPeriodContract {
	constructor(payCycle, isPending) {
		this.payCycle = payCycle;
		this.isPending = isPending;
	}
}

export default PayPeriodContract;